import React, { useState } from 'react';
import { Timer } from 'lucide-react';
import { useUI, useActions } from '../../context/AppContext';
import { COMMON_INPUT_CLASS, SWIMMING_STYLES } from '../../utils/constants';
import { getDayFromDate, getTodayISODate } from '../../utils/dateUtils';
import ConfirmClickButton from '../ui/ConfirmClickButton';

/** dk:ss.cc — saniye 00–59 */
const SWIM_TIME_PATTERN = '^\\d{1,2}:[0-5]\\d\\.\\d{2}$';
const SWIM_TIME_REGEX = new RegExp(SWIM_TIME_PATTERN);

const SwimmingRecordForm = ({ student, onSuccess }) => {
  const { showToast } = useUI();
  const { createSwimmingRecord } = useActions();
  const [selectedDate, setSelectedDate] = useState(getTodayISODate());
  const [submitting, setSubmitting] = useState(false);
  const autoDay = getDayFromDate(selectedDate);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        if (submitting) return;
        const timeValue = e.target.time.value.trim();
        if (!SWIM_TIME_REGEX.test(timeValue)) {
          showToast('Lütfen geçerli bir süre formatı girin. Örn: 00:25.40', 'error');
          return;
        }
        if (selectedDate > getTodayISODate()) {
          showToast('Derece tarihi ileri bir gün olamaz.', 'error');
          return;
        }
        setSubmitting(true);
        try {
          await createSwimmingRecord(student, {
            style: e.target.style.value,
            time: timeValue,
            dateISO: selectedDate,
          });
          onSuccess();
          showToast('Derece kaydedildi.');
        } catch (err) {
          showToast('Derece kaydedilemedi.', 'error');
        } finally {
          setSubmitting(false);
        }
      }}
      className="space-y-4"
    >
      <div>
        <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">
          Stil Seçimi
        </label>
        <select name="style" className={COMMON_INPUT_CLASS}>
          {SWIMMING_STYLES.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">
            Derece (Süre)
          </label>
          <input
            type="text"
            name="time"
            required
            placeholder="Örn: 00:25.40"
            pattern={SWIM_TIME_PATTERN}
            title="Format: dakika:saniye.yüzdebirlik — Örn: 00:25.40"
            className={COMMON_INPUT_CLASS}
          />
          <p className="text-[11px] text-slate-400 mt-1 ml-1">Format: dk:ss.cc — örn. 01:05.40</p>
        </div>
        <div>
          <label className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase">Tarih</label>
          <input
            type="date"
            name="date"
            required
            value={selectedDate}
            max={getTodayISODate()}
            onChange={(e) => setSelectedDate(e.target.value)}
            className={COMMON_INPUT_CLASS}
          />
          {autoDay && (
            <p className="mt-1.5 text-xs font-bold text-blue-600 dark:text-blue-400 flex items-center gap-1">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500 inline-block" />
              {autoDay}
            </p>
          )}
        </div>
      </div>
      <ConfirmClickButton
        type="submit"
        disabled={submitting}
        icon={Timer}
        iconSize={18}
        className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold mt-4 hover:bg-blue-700 transition-colors flex justify-center items-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {submitting ? 'Kaydediliyor...' : 'Dereceyi Kaydet'}
      </ConfirmClickButton>
    </form>
  );
};

export default SwimmingRecordForm;
